/*
 * @Author: your name
 * @Date: 2022-03-18 14:08:19
 * @LastEditTime: 2025-10-09 10:53:13
 * @LastEditors: 郭长生
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \ADIS\src\locales\system.ts
 */
export default {
    // 'system.tab2': 'Security setting',
    'system.tab2': 'Change Password',
    'system.tab3': 'Security question',
    'system.password.item1': 'Current password:',
    'system.password.item2': 'New password:',
    'system.password.item3': 'Confirm password:',
    'system.password.pleaseEnter': 'Please input',
    'system.password.rule': 'Password rules:',
    'system.password.rule1': '1. The password length is at least 12 characters',
    'system.password.rule2': '2. Letters, numbers and special characters allowed. Must contain at least 1 of each: Uppercase characters, lowercase characters, numbers and special characters',
    'system.password.confirmPasswordempty': 'The confirm password cannot be empty',
    'system.password.confirmPasswordRule1': 'The confirm password cannot be more than 20 digits',
    'system.password.confirmPasswordRule2': 'The confirm password cannot be less than 12 characters',
    'system.password.passwordRule3': 'The password supports numbers, English case and special symbols',
    'system.password.passwordRule4': 'The new password is inconsistent with the confirm new password',
    'system.password.passwordempty': 'New password cannot be empty',
    'system.password.passwordRule1': 'New password cannot be more than 20 digits',
    'system.password.passwordRule2': 'New password cannot be less than 12 characters',
    'system.password.passwordRule5': 'Password must contain at least one uppercase character',
    'system.password.passwordRule6': 'Password must contain at least one lowercase character',
    'system.password.passwordRule7': 'Password must contain at least one number',
    'system.password.passwordRule8': 'Password must contain at least one special character',
    'system.password.currentPasswordEmpty': 'Current password cannot be empty',
    'system.password.qaTips': 'You changed your initial password, so we need you to set a security question. If you forget your password, you can reset it by answering the security question.',
    'system.password.setQa': 'Set security question',
    'system.password.toSet': 'Go to setting',
    'system.password.changePasswordSuccess': 'Password modified successfully',
    'system.password.passwordWrong': 'The current password is incorrect',
    'system.password.changePasswordError': 'Password modification failed',

    'system.qa.qaTips2': 'You are modifying the security question. Please answer the original security question first:',
    'system.qa.qaTips3': 'You are selecting a security question. If you forget your password, you can reset it by answering the security question.',
    'system.qa.enterAnswer': 'Please enter the answer',
    'system.qa.nextStep': 'Next',
    'system.qa.currentAnswer': 'The answer cannot be empty',
    'system.qa.answerError': 'Wrong answer',
    'system.qa.failRequeat': 'Request error',
    'system.qa.setQaSuccess': 'Security question set successfully',
    'system.qa.setQaError': 'Security question setting failed',
    'system.qa.getQaListError': 'Failed to get current security question',
    'system.qa.choiceQa': 'Please select a security question:',

    'system.forgetPassword.title': 'Forget Password',
    'system.forgetPassword.findPassword': 'Find password',
    'system.forgetPassword.tip1': 'If you have not changed your password, please use the initial password',
    'system.forgetPassword.tip2': 'If you have changed your password, you can reset your password by answering the security question. Click "Next" to answer the security question',
    'system.forgetPassword.enterEnterprise': 'Please enter your Enterprise Account number:',
    'system.forgetPassword.pleaseQa': 'Please answer the security question',
    'system.forgetPassword.correct': 'Correct answer',
    'system.forgetPassword.resetPassword': 'The login password has been reset to 12345678',
    'system.forgetPassword.noQa': 'The enterprise number has no security question.',
    'system.forgetPassword.noQaTip': 'If you have any questions, please contact the after-sales.',
    'system.forgetPassword.enterpriseEmpty': 'Enterprise Account cannot be blank',
    'system.forgetPassword.enterpriseNoexistence': 'Enterprise Account does not exist',
    'system.forgetPassword.wrongEnterprise': 'Enterprise Account error',
    'system.forgetPassword.answerEmpty': 'The answer cannot be empty',
    'system.forgetPassword.findPasswordError': 'Failed to reset password',
    'system.forgetPassword.noQaTip1': 'If you want to change the initial password, we need you to set a security question first.',
    'system.forgetPassword.noQaTip2': 'If you forget your password later, you can reset it by answering the security question.',

    'system.back': 'Back',
    'system.language': 'Language',
    'system.remark': 'remarks',

    'system.forgetPassword.isAdminTip': 'Are you the Admin Account holder?',
    'system.forgetPassword.isAdminStep1': 'As the Admin Account holder, please answer the following security question.',
    'system.forgetPassword.userRule': 'Please contact your Administrator to change the password.',

    'system.changePassword.account': 'Account',
    'system.changePassword.countDown': "Please enter the verification code received in your email to complete registration. If you haven't received the verification code, you can request a new one after {times}.",
    'system.changePassword.countDown2': "We have sent an email to your current account. Please enter the verification code received in your email. If you haven't received the verification code, you can request a new one after {times}.",
    'system.changePassword.accountType': 'Admin Account Type',
    'system.changePassword.accountEmail': 'Email Account',
    'system.changePassword.accountGeneral': 'General Account',
    'system.changePassword.change': 'Change',
    'system.changePassword.pwdChangeOK': 'Password changed successfully',
    'system.changePassword.accountChangeOK': 'Account changed successfully',
    'system.changePassword.tip1': 'A new password has been generated',
    'system.changePassword.tip2': 'Please log in again',
    'system.changePassword.tip3': 'Copy invitation information',
    'system.changePassword.tip4': 'Content copied',
    'system.changePassword.tip5': 'Please log in again with your new account',
    'system.changePassword.dftPwd': 'Default Password',
    'system.changePassword.btnOK': 'OK',
    'system.changePassword.btnNext': 'Next Step',
    'system.changePassword.btnComplete': 'Complete',
    'system.changePassword.btnConfirm': 'Confirm',
    'system.changePassword.copyInfo': '[Adibot] has generated an administrator account for you: Account 【{account}】, Password 【{password}】. Please use this account and password to log in to ADIS and change your password promptly.'
};
